import { render } from "./VentureTargetCustomers.vue?vue&type=template&id=b0de9cd8"
import script from "./VentureTargetCustomers.vue?vue&type=script&lang=js"
export * from "./VentureTargetCustomers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__